<template>
  <div class="page-footer" :class="{ 'rtl--container': isArSite }">
    <div class="body--container">
      <div :class="['site-links']">
        <div class="list">
          <div class="list-item">
            <div class="title">
              {{ $t('GSC') }}
            </div>
            <div v-for="l in getLinks('1')" :key="l.id" class="sub-item">
              <a v-at-navigation="`footer::${getLastNodeInUrl(l.linkUrl)}`" @click="() => onLinkJump(l.linkUrl)" class="hover-under-line">{{ l.linkTitle }}</a>
            </div>
          </div>
          <div class="list-item">
            <div class="title">
              {{ $t('HSC') }}
            </div>
            <div v-for="l in getLinks('2')" :key="l.id" class="sub-item">
              <a v-at-navigation="`footer::${getLastNodeInUrl(l.linkUrl)}`" @click="() => onLinkJump(l.linkUrl)" class="hover-under-line">{{ l.linkTitle }}</a>
            </div>
          </div>
          <div class="list-item" style="flex-grow: 0.7">
            <div class="title">
              {{ $t('footer.quickLinks') }}
            </div>
            <div v-for="l in getLinks('3')" :key="l.id" class="sub-item">
              <a v-at-navigation="`footer::${getLastNodeInUrl(l.linkUrl)}`" @click="() => onLinkJump(l.linkUrl)" class="hover-under-line">{{ l.linkTitle }}</a>
            </div>
          </div>
          <div class="list-item" style="flex-grow: 0.7">
            <div class="title">
              {{ $t('footer.relatedLinks') }}
            </div>
            <div v-for="l in getLinks('4')" :key="l.id" class="sub-item">
              <a v-at-navigation="`footer::${getLastNodeInUrl(l.linkUrl)}`" @click="() => onLinkJump(l.linkUrl)" class="hover-under-line">{{ l.linkTitle }}</a>
            </div>
          </div>
          <div class="list-item">
            <div class="title">
              {{ $t('footer.contactUs') }}
            </div>
            <div class="sub-item">
              <span>{{ $t('footer.pleaseContact') }}</span>
              <a :href="`mailto:${$t('footer.contactEmail')}`" style="color: #1585FF">{{ $t('footer.contactEmail') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright-wrapper">
      <div class="body--container">
        <div class="copyright">
          <div class="copyright-content">
            <div class="copyright-text">
              {{ $t('global.copyrightInfo') }}
            </div>
            <div class="item-wrapper">
              <div v-for="(l, index) in getLinks('6')" :key="l.id" class="item">
                <a v-at-navigation="`footer::${getLastNodeInUrl(l.linkUrl)}`" :href="l.linkUrl" target="_blank" class="hover-under-line">{{ l.linkTitle }} </a>
                <div v-if="index+1<getLinks('6').length" class="divider-line" />
              </div>
            </div>
          </div>
          <div class="icons">
            <div v-for="(linkItem, index) in socialSiteUrl" :key="`${linkItem.id}_${index}`">
              <a
                v-if="linkItem.socialMediaList && linkItem.socialMediaList.length === 1"
                v-at-navigation="`footer::social::${linkItem.socialMediaList?.[0].title}`"
                :href="linkItem.socialMediaList?.[0].link"
                target="_blank"
              >
                <img :src="linkItem.linkImage">
              </a>
              <div v-else-if="linkItem.socialMediaList && linkItem.socialMediaList.length > 1">
                <Tooltip overlayClassName="tooltip-width-fixed">
                  <template #title>
                    <a
                      v-for="(item, subIndex) in linkItem.socialMediaList"
                      :key="`${item.link}_${subIndex}`"
                      v-at-navigation="`footer::social::${item.title}`"
                      class="sub-item-link"
                      :href="item.link"
                      target="_blank"
                    >
                      <span>{{ item.title }}</span>
                    </a>
                  </template>
                  <img :src="linkItem.linkImage">
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs, computed } from 'vue'
import { useStoreHooks } from '@/store/hook'
import { useRouter } from 'vue-router'
import { toServerUrl, getTenantMap } from '@/utils'
import { IFooterConfigItem } from '@/interface'
import { getLastNodeInUrl } from '@/utils/atModel'
import { Tooltip } from 'ant-design-vue'

export default defineComponent({
  components: {
    Tooltip
  },
  setup () {
    const router = useRouter()
    const { state: storeState, getters } = useStoreHooks()
    const links = storeState.global.footerConfig
    const state = reactive({
      showCooperativePartner: false
    })
    const isArSite = computed(() => storeState.global.isArSite)
    const getLinks = (type: string): IFooterConfigItem[] => {
      const arr: IFooterConfigItem[] = []
      links.forEach(l => {
        if (l.areaKind === type) {
          arr.push(l)
        }
      })
      return arr
    }
    const logoPic = computed(() => {
      const item = storeState.global.dictItemList.find(item => item.dictType === 'front_logo')
      return item ? item.dictLabel : ''
    })
    const toMainPage = () => {
      toServerUrl('/')
    }
    const onToTrainer = () => {
      router.push('/trainer')
    }
    const joinUs = () => {
      router.push('/join-us-as-a-trainer')
    }
    const onLinkJump = (url: string) => {
      const urlReg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/
      const matched = urlReg.exec(url)
      console.log('checked', location.hostname, matched)
      if (matched && matched[0] && location.hostname === matched[0]) {
        // 同站点，本页面打开
        window.location.href = url
      } else {
        window.open(url)
      }
    }
    state.showCooperativePartner = getLinks('5').length > 0

    return {
      ...toRefs(state),
      getLinks,
      toMainPage,
      onToTrainer,
      socialSiteUrl: computed(() => getters['global/socialLinks']),
      getLastNodeInUrl,
      joinUs,
      tenantId: computed(() => storeState.global.tenantId),
      tenantMap: getTenantMap(),
      isArSite,
      onLinkJump,
      logoPic
    }
  }
})
</script>
<style lang="less" src="./index.less"></style>
